import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Message } from 'src/app/models/message';
import { PrimarySource } from 'src/app/models/obs/primarysource';
import { AccessService } from 'src/app/services/access.service';
import { PrimarysourceService } from 'src/app/services/obs/primarysource.service';
import { Tier3Service } from 'src/app/services/obs/tier3.service';
import { TokenStorageService } from 'src/app/services/token-storage.service';


@Component({
  selector: 'app-admprimarysource-list',
  templateUrl: './admprimarysource-list.component.html',
  styleUrl: './admprimarysource-list.component.scss'
})
export class AdmprimarysourceListComponent implements OnInit {
  isBlockedTier3: boolean = false;
  source: PrimarySource = null;
  msg: Message;
  idtier3Selected: number = null;

  constructor(
    private sourceS: PrimarysourceService,
    private activedRoute: ActivatedRoute,
    private accesService: AccessService,
    private ts: TokenStorageService,
    private tier3Service: Tier3Service
  ) { }

  ngOnInit() {
    const params = this.activedRoute.snapshot.params;
    this.idtier3Selected = params['idtier3'];
    this.getGraph4t3(params['idtier3']);
    this.getPermission();
    this.getIsBlockedTier3(Number(this.idtier3Selected))
  }

  //bandera que controla la creacion de contenido
  accessMP: boolean = false
  //bandera que controla la eliminacion de contenido
  accessME: boolean = false
  //bandera que controla la eliminacion de contenido
  accessMD: boolean = false
  /* Permite determinar si el usuario actual tiene permiso para el modulo */
  inf = {}
  idTier3 = {}

  getPermission() {

    this.idTier3['id'] = this.activedRoute.snapshot.params['idtier3'] * 1;
    const data1 = this.idTier3;

    this.tier3Service.getIdTier1(data1).subscribe({
      next: res => {

        if (res['data'].idtier1 == 1 || res['data'].idtier1 == 5 || res['data'].idtier1 == 11 || res['data'].idtier1 == 12 || res['data'].idtier1 == 13 || res['data'].idtier1 == 15 || res['data'].idtier1 == 16) {
          this.inf['accessId'] = 1; //tendencia
        }
        if (res['data'].idtier1 == 2 || res['data'].idtier1 == 6 || res['data'].idtier1 == 22) {
          this.inf['accessId'] = 2;//riesgo
        }
        if (res['data'].idtier1 == 3 || res['data'].idtier1 == 4 || res['data'].idtier1 == 23) {
          this.inf['accessId'] = 3;//Oportunidad
        }
        if (res['data'].idtier1 == 7 || res['data'].idtier1 == 17) {
          this.inf['accessId'] = 4;//megatendencia
        }
        if (res['data'].idtier1 == 9 || res['data'].idtier1 == 14 || res['data'].idtier1 == 19) {
          this.inf['accessId'] = 5;//esceneario
        }
        if (res['data'].idtier1 == 8 || res['data'].idtier1 == 16 || res['data'].idtier1 == 17 || res['data'].idtier1 == 18 || res['data'].idtier1 == 19 || res['data'].idtier1 == 24) {
          this.inf['accessId'] = 6;//eventos futuros
        }
        if (res['data'].idtier1 == 20) {
          this.inf['accessId'] = 9;//fuerza
        }
        if (res['data'].idtier1 == 21) {
          this.inf['accessId'] = 10;//tecnologia  
        }

        this.inf['userId'] = this.ts.getUser().id;
        const data = this.inf;

        this.accesService.getPermissionUser(data).subscribe({
          next: res => {
            this.accessMP = res['result'].createSource;
            this.accessME = res['result'].editSource;
            this.accessMD = res['result'].deleteSource;
          },
          error: err => {
            this.msg = err;
          }
        });
      },
      error: err => {
        this.msg = err;
      }
    })
  }

  getGraph4t3(id: number) {
    this.sourceS.get4T3(id).subscribe({
      next: res => {
        this.source = res['data'];
      },
      error: err => {
        this.msg = err;
      }
    });
  }

  getIsBlockedTier3(id: number) {
    this.tier3Service.idT3blocked(id).subscribe({
      next: res => {
        this.isBlockedTier3 = res['isBlocked'];
      },
      error: err => {
        console.log("Error al verificar el estado de bloqueo: ", err);
      }
    });
  }
}
